// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__84Sja","empty":"ModalGraph_empty__3mY6P"};